import { gql } from "@apollo/client"
import { EledoAddress, EledoAddressInput } from "./EledoProfile"

export type EledoAccounting = {
  id: string
  level: number
	type: string
	startDate: Date
	accountingDay: number
	billTo: EledoAddress
}

export type EledoAccountingVars = {
}

export type EledoAccountingData = {
  accounting: EledoAccounting
}

export type EledoAccountingInput = {
  billTo?: EledoAddressInput
}

export type UpdateEledoAccountingVars = {
  accounting: EledoAccountingInput
}

export type UpdateEledoAccountingData = {
  updateAccounting: EledoAccounting
}

export const GET_ELEDO_ACCOUNTING = gql`
  query getAccounting {
    accounting { id level type startDate accountingDay billTo { full_name address_line_1 address_line_2 admin_area_2 postal_code country_code tax_id }
    }
  }
`;

export const UPDATE_ELEDO_ACCOUNTING = gql`
  mutation updateAccounting($accounting: EledoAccountingInput) {
    updateAccounting(accounting: $accounting) { id level type startDate accountingDay
      billTo { full_name address_line_1 address_line_2 admin_area_2 postal_code country_code tax_id }
    }
  }
`;